import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textPart: {
    width: '100%',
    marginTop: -160,
    color: theme.colors.light.freshPowder,
    textAlign: 'center',
  },
  title: {
    color: theme.colors.light.lightCyan,
    fontSize: 48,
    fontWeight: 500,
  },
  subTitle: {
    color: theme.colors.light.lightSteelBlue,
    fontSize: theme.fonts.sizes.font16PX,
    fontWeight: 500,
  },
}));

export const useStylesButton = makeStyles(theme => ({
  root: {
    width: '100%',
    height: 46,
    marginTop: 40,
    color: theme.colors.light.freshPowder,
    backgroundColor: theme.colors.orange.orange,
    '&:hover': {
      backgroundColor: theme.colors.orange.orange,
    },
  },
}));
